<template>
    <div id="artwork" class="container">
    	<div class="row">
    		<div class="col-xs-12 text-left">
    			<h5>Bio/Description</h5>
    		</div>

    		<div class="col-xs-12 bio">
    			<p v-html="text"></p>
    		</div>
    	</div>

    	<div class="row">
			<div class="col-xs-12" style="padding: 100px 0px;" v-if="loading">
	    		<loader color="ripple" size="150px"></loader>
	    	</div>
	    </div>

    	<div class="gallery row">
	    	<div v-for="image in gallery" v-if="!loading">
	    		<div class="image" :class="{removed: image.removed, remove: image.remove, edit: image.edit}" :style="{'padding-bottom': `calc(100% * ${image.h} / ${image.w} )`}" v-show="image.link != placeholder">
	    			<div class="lazzyLoad" :data-img="image.link" :loaded="image.loaded" @click="fancyBox(image)"></div>

		    		<div class="btn btn-remove" :class="{active: image.remove}" v-if="isOwner" @click="editImage($event, image, 'remove')">
		    			<span class="iconify icon:bytesize:close icon-inline:false e"></span>
		    			<span class="iconify icon:bytesize:close icon-inline:false c"></span>
		    			<div class="round round-active" @click="deleteImage(image)">REMOVE</div>
		    		</div>

		    		<div class="btn btn-edit" :class="{active: image.edit}" v-if="isOwner" @click="editImage($event, image, 'edit')">
		    			<span class="iconify icon:bytesize:edit icon-inline:false e"></span>
		    			<span class="iconify icon:bytesize:close icon-inline:false c"></span>
		    			<input type="text" v-model="image.title">
		    			<div class="round round-active" @click="updateImage(image)">SAVE</div>
		    		</div>
		    	</div>

		    	<div class="image placeholder" v-if="image.link == placeholder">
		    		<div class="lazzyLoad" loaded="true" :style="{'background-image': `url('${image.link}')`}"></div>
		    	</div>
	    	</div>
    	</div>
	</div>
</template>

<style type="text/css">
	#artwork{ min-height: 0px; padding: 0px 30px; }

	#artwork .bio{ margin: 0px 0px 10px 0px; font-size: 16px; text-align: justify;}
	#artwork .bio strong{ font-weight: 900; }

	#artwork h5{ line-height: 45px; }

	#artwork .row > div { padding: 0px 10px; }
	#artwork .dropzone{ border: 2px dashed #ccc; min-height: 200px; margin-bottom: 20px; border-radius: 3px; padding: 30px 100px; cursor: pointer; }
	#artwork .dropzone:hover{ border: 2px dashed #232533; }
	#artwork .dropzone .title{ font-size: 22px; color: #232533; padding: 30px; line-height: 20px; text-transform: uppercase; pointer-events: none; user-select: none; }
	#artwork .dropzone .title small{ opacity: 0.4; font-size: 60%; }

	#artwork .dropzone .btn-upload{ margin-top: 20px; }

	#artwork .upload-preview { margin-bottom: 5px; border-radius: 4px; padding: 6px 0px; height: 54px; }
	#artwork .upload-preview.odd{ background: #EEE; }
	#artwork .upload-preview img{ display: inline-block; max-height: 42px; width: auto; border-radius: 2px; }
	#artwork .upload-preview .details{}
	#artwork .upload-preview .details .name{ display: block; font-size: 16px; color: #232533; font-weight: bold;  overflow: hidden; text-overflow: ellipsis; }
	#artwork .upload-preview .details .size{ font-size: 14px; }

	#artwork .upload-preview .options > span { display: inline-block; }
	#artwork .upload-preview .options .iconify{ font-size: 42px; }
	#artwork .upload-preview .options .loading{ position: relative; width: 42px; height: 42px; padding: 0px;}
	#artwork .upload-preview .options .loading img { position: absolute; top: -24px; left: -24px; width: 90px; height: 90px; max-height: initial; }

	#artwork .gallery{ background: #FFF; padding: 30px 15px; margin: 0px -30px;  }
	#artwork .gallery .image{ -webkit-transform-style: preserve-3d; position: relative; background: #DDD; padding-bottom: 0%; border-radius: 3px; overflow: hidden; margin-bottom: 20px; break-inside: avoid-column; }
	#artwork .gallery .image.placeholder{ padding-bottom: 75%; }

	#artwork .gallery .image .lazzyLoad{ position: absolute; width: 100%; height: 100%; min-height: 100px; background-size: 100%; opacity: 0; transition: all 0.35s ease-in;}
	#artwork .gallery .image .lazzyLoad[loaded="true"]{ transition: none; opacity: 1; }
	#artwork .gallery .image img{ position: relative; display: block; opacity: 0; width: 100%; }

	#artwork .gallery .image .btn{ position: absolute; top: 10px; right: 10px; width: 34px; height: 34px; border-radius: 20px; border:none; display: none; color: #FFF; box-shadow: 1px 1px 4px 0px #000;  transition: all 0.2s ease-in; z-index: 1;}
	#artwork .gallery .image .btn .iconify{ position: absolute; top: 0px; right: 0px; transition: all 0.2s ease-in; width: 34px; height: 34px; padding: 8px; }
	#artwork .gallery .image .btn .iconify.e{ opacity: 1; }
	#artwork .gallery .image .btn .iconify.c{ opacity: 0; }
	#artwork .gallery .image .btn:active{ transform-origin: center; transform: scale(0.95); box-shadow: 0px 0px 0px 0px #000;}
	#artwork .gallery .image:hover .btn{ display: block; }
	#artwork .gallery .image .btn input{ display: none; position: absolute; bottom: 60px; left: 40px; width: calc(100% - 80px); transition: all 0.2s linear 1s; }
	#artwork .gallery .image .btn .round{ display: none; position: absolute; bottom: 30px; left: 40px; width: calc(100% - 80px); padding: 6px; }

	#artwork .gallery .image .btn.active{ display: block; top: -20px; right: -20px; width: calc(100% + 40px); height: calc(100% + 40px); z-index: 2; }
	#artwork .gallery .image .btn.active .iconify.e{ top: 29px; right: 29px; opacity: 0; }
	#artwork .gallery .image .btn.active .iconify.c{ top: 29px; right: 29px; opacity: 1; }
	#artwork .gallery .image .btn.active input{ display: block; }
	#artwork .gallery .image .btn.active .round{ display: block; }

	#artwork .gallery .image .btn-remove{ background: #ef5656ff; }
	#artwork .gallery .image .btn-remove.active { background: #ef5656cc; }
	#artwork .gallery .image.edit .btn-remove{ opacity: 0; }

	#artwork .gallery .image .btn-edit{ right: 50px; background: #3d404fff;}
	#artwork .gallery .image .btn-edit.active { background: #3d404fcc; }
	#artwork .gallery .image.remove .btn-edit{ opacity: 0; }

	#artwork .gallery .image.removed{ padding-bottom: 0%; }
	#artwork .gallery .image.removed .lazzyLoad{ filter: grayscale(1) blur(3px); opacity: 0.6 !important; transition: all 0.5s linear; }
	#artwork .gallery .image.removed .btn-remove{ display: none; }
</style> 

<script>
export default {
    components: {
        'loader': require('@/components/Loader.vue').default,
    },

    props: ['user'],

    data() {
        return {
        	text: this.user.info.description,

        	files: [],
        	gallery: [],
        	album: {
		        "id": null,
		        "deletehash": null
		    },

		    loading: true,
		    placeholder: "https://dummyimage.com/400x300/eee/fff.png&text=soundfeed" 
		}
	},

	mounted() {
		this.initGallery();
		console.log('AAAAAAAAAAA', this.user);
	},

	methods:{
		openFileUpload(){
			$('#image-upload').click();
		},

		addFile(e) {
			let droppedFiles = e.target.files || e.dataTransfer.files;
			if(!droppedFiles) return;

			// this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
			([...droppedFiles]).forEach(f => {
				var ext = f.name.split('.').pop();
				var size = f.size / 1024 / 1024;
				var error = false;

				if (size > 10){
					error = {
						code: 2,
						msg: `File too large (${size.toFixed(1)} MB). Maximum filesize allowed: 10 MB.`
					}
				}

				if (['jpg', 'jpeg', 'png', 'gif'].indexOf(ext) == -1){
					error = {
						code: 1,
						msg: `Invalid extension (.${ext}). You are allowed to upload only JPG, JPEG, PNG or GIF files.`
					}
				}

				var reader = new FileReader();
				// var vm = this;
				reader.onload = (e) => {
					this.files.push({
						data: f, 
						preview: (error && error.code == 1) ? false : e.target.result,
						state: null,
						error: error
					});


					this.upload();
				}

				reader.readAsDataURL(f);
			});
		},

		deleteImage(file){
			file.removed = true;
			// return; 
			this.$http.delete(`https://imgur-apiv3.p.rapidapi.com/3/image/${file.id}/images`).then((success) => {
				this.gallery = this.gallery.filter(f => { return f != file; });
				this.fillGallery();
            }, (err) => {
            	file.removed = false;
            });
		},

		updateImage(file){
			// return; 
			this.$http.post(`https://imgur-apiv3.p.rapidapi.com/3/image/${file.id}`, {title: file.title}).then((success) => {
				this.editImage(false, file, 'updated');
            }, (err) => {
				console.log('no');
            });
		},

		editImage(ev, image, action){
			if ( image[action] && $(ev.target).is('svg') ){
				image[action] = false;
			}else{
				image[action] = true;
			}

			if ( action == 'updated' ){
				image.edit = false;
			}
		},

		initGallery(){
			this.$http.get(`${App.restApi}/api/user/${this.user.id}/custom-data`).then((success) => {
				this.user.custom_data = success.data.custom_data ? success.data.custom_data : {};

				if (this.user.custom_data.imgur_album){
					this.album = this.user.custom_data.imgur_album;
					this.getGallery();
				}else{
					if (this.isOwner){
						// create album son..
						var reqData = {
							'Title': App.user.name + "'s Gallery",
							'privacy': 'secret',
						}

						this.$http.post('https://imgur-apiv3.p.rapidapi.com/3/album', reqData).then((success) => {
			                this.user.custom_data.imgur_album = success.data.data;
			                this.album = this.user.custom_data.imgur_album;

			                this.$http.put(`${App.restApi}/api/user/${this.user.id}/custom-data`, {custom_data: this.user.custom_data}).then((success) => {
			                	this.getGallery();
				            }, (err) => {
				                console.log('ERROR SAVING CUSTOM DATA', err);
				            });
			            }, (err) => {
			                console.log('ERROR CREATING IMGUR ALBUM', err);
			            });
			        }else{
			        	this.fillGallery();
			        	this.loading = false;
			        }
				}
			});
		},

		getGallery(){
			this.loading = true;
			this.$http.get(`https://imgur-apiv3.p.rapidapi.com/3/album/${this.album.id}/images`).then((success) => {
				if (success.data.data.length){
					$.each(success.data.data.reverse(), (i, img) => {
						this.gallery.push({
							id: img.id,
							link: img.link,
							title: img.title,
							desc: img.description,
							w: img.width,
							h: img.height,
							removed: false,
							loaded: false,
							new: false,
							edit: false,
							remove: false,
						})	
					})
                }
                this.fillGallery();

                this.loading = false;
            }, (err) => {
            	this.loading = false;
            });
		},

		fancyBox(image){
			var fbox = [];
			var index = this.gallery.indexOf(image);

			$.each(this.gallery, (i,f) => {
				fbox.push({
					src  : f.link,
					opts : {
						caption : f.title ? f.title : '',
					}
				})
			});

			$.fancybox.open(fbox, {
				infobar: true,
				loop: true,
				thumbs:{
					autostart: false,
				},
			 	buttons: ["zoom", "slideShow", "fullScreen", "download", "thumbs", "close"],
			}, index);
		},

		upload() {
			$.each(this.files, (x,f) => {
				// skip errors
				if (f.error){ 
					f.state = 'error'; 
				}

				///skip already uploaded files
				if (f.state === true || f.state === 'pending' || f.state === 'error') return;
				
				f.state = 'pending';

				var formData = new FormData();
				formData.append('image', f.data);
				formData.append('album', this.album.id);

				this.$http.post('https://imgur-apiv3.p.rapidapi.com/3/image', formData).then((success) => {
	                f.state = true;
	                var img = success.data.data;

	                this.gallery.unshift({
						id: img.id,
						link: f.preview,
						title: img.title,
						desc: img.description,
						w: img.width,
						h: img.height,
						removed: false,
						loaded: true,
						new: true,
						edit: false,
						remove: false,
	                });

	                this.fillGallery();
	            },(err) => {
	                f.state = false;
	                f.error = {
	                	code: 3,
	                	msg: 'Upload error. ' + err.data.data.error
	                };
	            });				
			})
		},

		fillGallery(){
			var newGallery = $.grep(this.gallery, (f) => { return f.link != this.placeholder; });
			var slots = Math.max(0, 4 - newGallery.length);
			var aux = Array(slots).fill({
				link: this.placeholder,
				w: 400,
				h: 300
			});

			this.gallery = newGallery.concat(aux);
		},

		saveBio(){
            var data = {
            	city: this.user.info.city,
            	contact_email: this.user.info.contact_email,
            	country_id: this.user.country_id,
            	name: this.user.name,
            	private_hashtag: this.user.info.private_hashtag,
            	public_hashtag: this.user.info.public_hashtag,
            	description: this.text
            }

			this.$http.put(`${App.restApi}/api/user/${this.user.id}`, data).then((success) => {
				this.editBio = false;
			}, (err) => {
				console.log('NO');
			});
		}
	},

	computed: {
		uploadDisabled() {
			return this.files.length === 0;
		},

		isDone(){
			return $.grep(this.files, (f) => { return f.state == 'null' || f.state == 'pending'; }).length == 0 && this.files.length;
		},

		isOwner(){
			return false;//App.user.id == this.user.id;
		}
	},

	watch: {
		gallery(oldGallery, newGallery) {
			// if (newGallery.length > oldGallery.length){
				this.$nextTick(() => {
	        	    LazzyLoad();
	        	});
	        // };
		},

		isDone() {
			if (this.isDone){ 
				$.each(this.files, (x,f) => {
	                setTimeout(() => {
	                	this.files = $.grep(this.files, (c) => { return c != f; });
	                }, (f.state == true ? 2500 : 6000));
	            });
			}
		}
	}
}
</script>
